import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {CustomerPortfolio, netContributedAmount} from 'src/app/domain/model/customer-portfolio.model';
import CustomerPortfolioApi from 'src/app/domain/service/api/customer-portfolio.api';
import ProductRouteResolver from 'src/app/domain/service/route-resolver/product-route-resolver.service';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import {Modal} from 'src/app/infrastructure/service/modal.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-premium-modal',
  templateUrl: 'premium-modal.page.html',
})
export class PremiumModalPage extends WebPage {
  selectedPortfolio: CustomerPortfolio | null;
  actualDepositedAmount: number;
  amountToBePremium: number;

  constructor(
    private readonly modal: Modal,
    private readonly portfolioApi: CustomerPortfolioApi,
    private readonly productRouteResolver: ProductRouteResolver,
    router: Router,
    appEnvironment: AppEnvironmentService,
    titleService: Title,
  ) {
    super(router, appEnvironment, titleService);
    this.amountToBePremium = appEnvironment.investmentPlanAmountToBePremium();
  }

  public actualDepositedRatio(): number {
    const ratio = this.actualDepositedAmount / this.amountToBePremium;
    return ratio < 1.0 ?  ratio : 1.0;
  }

  public close(): void {
    this.modal.dismiss();
  }

  public goToCashTransferIn(): void {
    this.router.navigate([this.productRouteResolver.resolveAddMoneyUrl(this.selectedPortfolio)]);
    this.close();
  }

  public goToTransferFunds(): void {
    this.router.navigate([this.productRouteResolver.resolveInvestmentTransferFunds()]);
    this.close();
  }

  protected onInit() {
    this.subscribe(
      this.portfolioApi.selected(),
      (customerPortfolio: CustomerPortfolio) => {
        this.selectedPortfolio = customerPortfolio;
        this.actualDepositedAmount = netContributedAmount(customerPortfolio);
      }
    );
  }
}
